import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import {
  DialogRef,
  ModalComponent
} from 'angular2-modal';

import { DialogPreset } from './presets/dialog-preset';
import { DropInPreset } from './presets/dropin-preset';

export interface VEXButtonHandler {
  (cmp: ModalComponent<DialogPreset>, $event: MouseEvent): void;
}

/**
 * Interface for button definition
 */
export interface VEXButtonConfig {
  cssClass: string;
  caption: string;
  onClick: VEXButtonHandler;
}

export interface VEXButtonClickEvent {
  btn: VEXButtonConfig;
  $event: MouseEvent;
}
/**
 * A Dialog is a
 */
export class VEXDialogButtons {
/**
 * A collection of button configurations, each configuration is a button to display.
 */
public buttons: VEXButtonConfig[];
/**
 * Emitted when a button was clicked
 */
public onButtonClick = new EventEmitter<VEXButtonClickEvent>();
/**
 * @param {?} btn
 * @param {?} $event
 * @return {?}
 */
onClick(btn: any, $event: MouseEvent) {
    $event.stopPropagation();
    this.onButtonClick.emit({btn, $event});
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'vex-dialog-buttons',
  encapsulation: ViewEncapsulation.None,
  template: `<div class="vex-dialog-buttons">
    <button type="button" 
         *ngFor="let btn of buttons;"
         [class]="btn.cssClass"
         (click)="onClick(btn, $event)">{{btn.caption}}</button>
</div>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'buttons': [{ type: Input },],
'onButtonClick': [{ type: Output },],
};
}

function VEXDialogButtons_tsickle_Closure_declarations() {
/** @type {?} */
VEXDialogButtons.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VEXDialogButtons.ctorParameters;
/** @type {?} */
VEXDialogButtons.propDecorators;
/**
 * A collection of button configurations, each configuration is a button to display.
 * @type {?}
 */
VEXDialogButtons.prototype.buttons;
/**
 * Emitted when a button was clicked
 * @type {?}
 */
VEXDialogButtons.prototype.onButtonClick;
}

/**
 * A Dialog with customized buttons wrapped in a form.
 * 
 */
export class DialogFormModal implements ModalComponent<DialogPreset> {
public context: DialogPreset;
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<DialogPreset>) {
    this.context = dialog.context;
  }
/**
 * @param {?} $event
 * @return {?}
 */
onButtonClick($event: VEXButtonClickEvent) {
    $event.btn.onClick(this, $event.$event);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'modal-dialog',
  encapsulation: ViewEncapsulation.None,
  template: `<form class="vex-dialog-form">
    <ng-container *ngComponentOutlet="context.content"></ng-container>
    <vex-dialog-buttons [buttons]="context.buttons"
                        (onButtonClick)="onButtonClick($event)"></vex-dialog-buttons>
</form>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function DialogFormModal_tsickle_Closure_declarations() {
/** @type {?} */
DialogFormModal.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogFormModal.ctorParameters;
/** @type {?} */
DialogFormModal.prototype.context;
/** @type {?} */
DialogFormModal.prototype.dialog;
}

export class FormDropIn implements ModalComponent<DropInPreset> {
public context: DropInPreset;
/**
 * @param {?} dialog
 */
constructor(public dialog: DialogRef<DropInPreset>) {
    this.context = dialog.context;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'drop-in-dialog',
  encapsulation: ViewEncapsulation.None,
  template:
`<div class="vex-dialog-message">{{context.message}}</div>
 <div *ngIf="context.showInput" class="vex-dialog-input">
   <input #input
          autofocus
          name="vex" 
          type="text" 
          class="vex-dialog-prompt-input"
           (change)="context.defaultResult = input.value" 
          placeholder="{{context.placeholder}}">
 </div>
 <div *ngIf="context.showCloseButton" 
      [class]="context.closeClassName"
      (click)="dialog.dismiss()"></div>`
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DialogRef, },
];
}

function FormDropIn_tsickle_Closure_declarations() {
/** @type {?} */
FormDropIn.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormDropIn.ctorParameters;
/** @type {?} */
FormDropIn.prototype.context;
/** @type {?} */
FormDropIn.prototype.dialog;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
